<template>
    <tfoot role="rowgroup">
        <tr v-for="(item, rowIndex) in rows" :key="rowIndex">
            <td v-if="showColumnAction" class="md-editable-grid-cell-footer"></td>
            <template v-for="(field, columnIndex) in columns">
                <editable-footer-cell
                    :key="columnIndex"
                    :rowIndex="rowIndex"
                    :columnIndex="columnIndex"
                    :value="item[field.key]"
                    :frozen="frozen(field)"
                    :alignFrozen="alignFrozen(field)"
                    :cellStyle="cellStyle(field)"
                    :cellClass="cellClass(field)"
                ></editable-footer-cell>
            </template>
        </tr>
    </tfoot>
</template>

<script>
import EditableFooterCell from './EditableFooterCell.vue';
export default {
    name: 'EditableTableFooter',
    props: {
        showColumnAction: {
            type: Boolean,
            default: false
        },
        columns: {
            type: Array,
            required: true,
            validator: value => {
                return value.every(
                    column =>
                        typeof column.key === 'string' &&
                        typeof column.label === 'string' &&
                        (column.editable === undefined || typeof column.editable === 'boolean') &&
                        (column.class === undefined || typeof column.class === 'string') &&
                        (column.dataType === undefined || typeof column.dataType === 'string') &&
                        (column.formatter === undefined ||
                            typeof column.formatter === 'function') &&
                        (column.props === undefined || typeof column.props === 'object')
                );
            }
        },
        rows: {
            type: Array,
            required: true
        }
    },
    components: {
        EditableFooterCell
    },
    methods: {
        frozen(field) {
            return field.props?.frozen;
        },
        alignFrozen(field) {
            return field.props?.alignFrozen;
        },
        cellStyle(field) {
            return field.props?.cellStyle;
        },
        cellClass(field) {
            return field.props?.cellClass;
        }
    }
};
</script>
